export default "__VITE_ASSET__CIbUXt9y__"